import React, { Component, Fragment } from 'react';
import Alerts from '../../components/alerts';
import QueuePendingRefresh from '../../components/cache/queuePendingRefreshComponent'
import RefreshProjectModal from '../../components/modalRefreshProject';
import OldProjects from '../../components/oldProjects'
import { NavLink } from "react-router-dom";

import { Spinner, Row, Col, Button, ButtonGroup, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import service from '../../services/cacheService';

export default class Cache extends Component {
    constructor(props) {
		super(props)
        var autoRefreshInStorage = localStorage.getItem('isAutoRefresEnabled');
        var isAutoRefreshEnabled = autoRefreshInStorage === true || autoRefreshInStorage === "true" || false;
		this.state = {
			isQueuePendingRefreshLoading: true,
            isOldProjectsLoading: true,
            alerts: [],
            isRefreshModalDisplayed: false,
            refreshProjectId: '',
            oldProjects: [],
            data: { activities: [] },
            filterServiceBusProjectId: null,
            isAutoRefreshEnabled: isAutoRefreshEnabled,
            refreshTime: 30
		}
	}

    async componentWillMount() {
		await this.getQueuePendingRefresh();
        await this.getOldProjects();
        this.toggleAutoRefreshInterval();        
	}

    componentWillUnmount() {
        clearInterval(this.autoRefreshInterval);
    }

    toggleAutoRefreshInterval (currentState) {
        //We sometimes want to disable the interval before the state changes
        if(currentState === undefined || currentState === null)
            currentState = this.state.isAutoRefreshEnabled;

        if(currentState === true) {
            this.autoRefreshInterval = setInterval(this.refreshAllSections, this.state.refreshTime * 1000);
        }
        else {
            clearInterval(this.autoRefreshInterval);
        }
    }

    getQueuePendingRefresh = async () => {
        this.setState({
            isQueuePendingRefreshLoading: true
        });
        try {
			const res = await service.getQueuePendingRefresh();
			if (res != null) {
				this.setState({
					isQueuePendingRefreshLoading: false,
					data: res
				});
			}
		} catch (e) {
			this.setState({
                isQueuePendingRefreshLoading: false,
				alerts: [{type:'danger', msg:'Problem contacting the service.'}],
			});
		}
    }

    getOldProjects = async () => {
        this.setState({
            isOldProjectsLoading: true
        });
        try {
			const res = await service.getOldProjects();
			if (res != null) {
				this.setState({
					isOldProjectsLoading: false,
					oldProjects: res
				});
			}
		} catch (e) {
			this.setState({
                isOldProjectsLoading: false,
				alerts: [{type:'danger', msg:'Problem contacting the service.'}],
			});
		}
    }

    openRefreshProjectModal(projectId) {
        this.setState({
            isRefreshModalDisplayed: true,
            refreshProjectId: projectId || ''
        });
    }

    refreshOldProjectSection = async () => {
        await this.getOldProjects();
        this.setState({
            alerts:[]
        });
    }

    refreshQueuesSections = async () => {
        await this.getQueuePendingRefresh();
        this.setState({
            alerts:[],
            filterServiceBusProjectId: ''
        });
    }

    refreshAllSections = async () => {
        await this.refreshOldProjectSection();
        await this.refreshQueuesSections();
        this.setState({
            alerts:[]
        });
    }

    handleRefreshModalClose = async (isConfirmClicked, projectId, types) => {
        if(types === undefined)
            types=[];

        var displayTypes = types && types.length > 0 ? types.join() : 'All';

        if(isConfirmClicked && (!projectId || projectId.length === 0)){
            this.setState({
                isRefreshModalDisplayed: false,
                refreshProjectId: '',
                alerts: [{type:'danger', msg:'The ProjectId was not set!'}],
            });
            return;
        }

        var alerts = [];
        var isSuccess = false;
        if(isConfirmClicked && projectId && projectId.length > 0){
            try {
                const res = await service.refreshProject(projectId, types);
                if (res != null) {
                    alerts = [{type:'success', msg:'The Project was sent for refresh in the queue for types: ' + displayTypes}];
                    isSuccess = true;
                }
            } catch (error) {
                var resp = error.response;
                var backupMessage = 'An error occurred while refreshing the project cache.';
                var message = resp && resp.data ? (resp.data.message || backupMessage) : backupMessage;
                alerts = [{type:'danger', msg: message}];
            }
        }

        this.setState({
            isRefreshModalDisplayed: false,
            refreshProjectId: '',
            alerts: alerts,
        });

        if(isSuccess === true){
            await this.getQueuePendingRefresh();
        }
    }

    handleClearAlert = (alert) => {
        var alerts = this.state.alerts || [];
        var alertIndex = alerts.indexOf(alert);
        if(alertIndex > -1)
        {
            alerts.splice(alertIndex, 1);
            this.setState({
                alerts: alerts || []
            });
        }
    }

    searchBusByProjectId = (e) => {
        var projectId = e.target.value || '';

        this.setState({
            filterServiceBusProjectId: projectId
        });
    }

    filterServiceBusItems = (items) => {
        var filteredItems = items || [];
        var total = items ? items.length : 0;
        if(this.state.filterServiceBusProjectId && this.state.filterServiceBusProjectId.length > 0){
            filteredItems = filteredItems.filter((item) => {
                return item.projectId.indexOf(this.state.filterServiceBusProjectId) > -1;
            });
        }
        return {
            items: filteredItems || [],
            total : total
        }
    }
    clearServiceBusFilter =() => {
        this.setState({
            filterServiceBusProjectId: ''
        });

        this.txtSearchBusByProjectId.value = '';
    }

    handleAutoRefreshSwitchChange = (e) => {
        
        var currentState = this.state.isAutoRefreshEnabled || false;
        currentState = !currentState;
        localStorage.setItem('isAutoRefresEnabled', currentState);
        this.setState({
            isAutoRefreshEnabled: currentState
        });

        this.toggleAutoRefreshInterval(currentState);
    }

    handleDocsClick = () =>{
        this.props.history.push(`/docs`);
    }

  render() {
      var filteredActivities = this.filterServiceBusItems(this.state.data.activities || []);
      var filteredNotes = this.filterServiceBusItems(this.state.data.notes || []);
      var filteredAllowances = this.filterServiceBusItems(this.state.data.allowances || []);
      var filteredPOs = this.filterServiceBusItems(this.state.data.purchaseOrders || []);
      var filteredProjects = this.filterServiceBusItems(this.state.data.projects || []);
      var isLoading = this.state.isQueuePendingRefreshLoading === true || this.state.isOldProjectsLoading === true;
    return (
        <Fragment>
            {
                isLoading ? 
                <Spinner id="spinner" animation="border" variant="primary" /> : 
                <Fragment>
                    <Alerts alerts={this.state.alerts} handleClearAlert={this.handleClearAlert} />   
                    <Row className="cache-section-container margin-bottom-10px">
                        <Fragment>
                            <Col xl={6}>
                                <OverlayTrigger placement="bottom" overlay={<Tooltip>Toggles the Auto-Refresh logic that refreshes the sections below every {this.state.refreshTime} seconds.</Tooltip>}>
                                    <div className='custom-control custom-switch d-inline-block'>
                                        <input
                                            type='checkbox'
                                            className='custom-control-input'
                                            id='autoRefreshSwitch'
                                            checked={this.state.isAutoRefreshEnabled}
                                            onChange={this.handleAutoRefreshSwitchChange}
                                            readOnly
                                        />
                                        <label className='custom-control-label' htmlFor='autoRefreshSwitch'>
                                            Auto-Refresh
                                        </label>
                                    </div>
                                </OverlayTrigger>
                            </Col>
                            <Col xl={6} className="text-right">
                                <OverlayTrigger placement="bottom" overlay={<Tooltip>Click here for more information about the admin portal, cache and general documentation</Tooltip>}>
                                    <Button className="btn btn-info" onClick={this.handleDocsClick}>
                                            <span>Info <i className="fa fa-info-circle"></i></span>
                                    </Button>
                                </OverlayTrigger>
                                <span>&nbsp;</span>
                                <OverlayTrigger placement="bottom" overlay={<Tooltip>Specify a project (and a type [optional, no selection = all]) which will be sent to the end of the Service Bus queue for processing.</Tooltip>}>
                                    <Button 
                                        id="btnRefreshProject"
                                        variant="success"
                                        onClick={() => this.openRefreshProjectModal()}>
                                            <i className="fas fa-redo"></i> Refresh Project
                                    </Button>
                                </OverlayTrigger>
                                <span>&nbsp;</span>
                                <OverlayTrigger placement="bottom" overlay={<Tooltip>Refresh all the sections below.</Tooltip>}>
                                    <Button id="btnRefreshAll" variant="info" onClick={() => this.refreshAllSections()} title="Refresh All"><i className="fas fa-sync"></i></Button>
                                </OverlayTrigger>
                            </Col>
                        </Fragment>
                    </Row>
                    <Row className="cache-section-container margin-bottom-10px">
                        <Col xl={12}>
                            <div className="input-group w-100">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <OverlayTrigger placement="bottom" overlay={<Tooltip>The Projects in this section are retrieved from the database. Each section has the last updated for the given type such as: ActivityCacheLastUpdated, AllowanceCacheLastUpdated etc.</Tooltip>}>
                                            <span><b>Old Projects</b>&nbsp;<i className="fa fa-info-circle"></i></span>
                                        </OverlayTrigger>
                                    </span>
                                </div>
                                <input disabled={true} className="form-control" />
                                <div className="input-group-append pointer-cursor" onClick={()=> this.refreshOldProjectSection()} >
                                        <OverlayTrigger placement="bottom" overlay={<Tooltip>Refresh the Old Projects section below</Tooltip>}>
                                            <span className="input-group-text"><i className="fas fa-sync"></i></span>
                                        </OverlayTrigger>
                                </div>
                            </div>
                        </Col>
                        <Col xl={12}>
                        {
                            <Fragment>
                                <OldProjects title="Old Projects" items={this.state.oldProjects} handleProjectRefresh={(projectId) => this.openRefreshProjectModal(projectId)} />
                            </Fragment>
                        }
                        </Col>
                    </Row>
                    <hr/>
                    <Row className="cache-section-container">
                        <Fragment>
                            <Col xl={12}>
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <OverlayTrigger placement="bottom" overlay={<Tooltip>The Projects in this section are retrieved from the Service bus. The search is happening in the browser. If you want to revert things back to how they were, just clear the filter.</Tooltip>}>
                                                <span><b>Service Bus Queue</b>&nbsp;<i className="fa fa-info-circle"></i></span>
                                            </OverlayTrigger>
                                        </span>
                                    </div>
                                    <input 
                                        id="txtSearchBusByProjectId" 
                                        name="txtSearchBusByProjectId" 
                                        className="form-control"
                                        tabIndex="1"
                                        placeholder="Search"
                                        onChange={(e) => this.searchBusByProjectId(e)}
                                        ref={(input) => { this.txtSearchBusByProjectId = input; }} />
                                    <div className="input-group-append pointer-cursor" onClick={()=> this.clearServiceBusFilter()} >
                                            <OverlayTrigger placement="bottom" overlay={<Tooltip>Clear the filter</Tooltip>}>
                                            <span className="input-group-text"><i className="fas fa-eraser"></i></span>
                                            </OverlayTrigger>
                                       
                                    </div>
                                    <div className="input-group-append pointer-cursor" onClick={()=> this.refreshQueuesSections()} >
                                        <OverlayTrigger placement="bottom" overlay={<Tooltip>Refresh the Service Bus section below</Tooltip>}>
                                            <span className="input-group-text"><i className="fas fa-sync"></i></span>
                                        </OverlayTrigger>
                                    </div>
                                </div>                                
                            </Col>
                            <Col xl={12}>
                                {
                                    <Fragment>
                                        <QueuePendingRefresh title="Activities" items={filteredActivities.items} total={filteredActivities.total} />
                                    </Fragment>
                                }
                            </Col>
                            <Col xl={12}>
                                {
                                    <Fragment>
                                        <QueuePendingRefresh title="Notes" items={filteredNotes.items} total={filteredNotes.total} />
                                    </Fragment>
                                }
                            </Col>
                            <Col xl={12}>
                                {
                                    <Fragment>
                                        <QueuePendingRefresh title="Allowances" items={filteredAllowances.items} total={filteredAllowances.total} />
                                    </Fragment>
                                }
                            </Col>
                            <Col xl={12}>
                                {
                                    <Fragment>
                                        <QueuePendingRefresh title="POs" items={filteredPOs.items} total={filteredPOs.total} />
                                    </Fragment>
                                }
                            </Col>
                            <Col xl={12}>
                                {
                                    <Fragment>
                                        <QueuePendingRefresh title="Projects" items={filteredProjects.items} total={filteredProjects.total} />
                                    </Fragment>
                                }
                            </Col>
                        </Fragment>
                    </Row>
                    
                    <Row>
                        <Col xl={12}>
                            <p>
                                
                            </p>
                            <hr/>
                        </Col>
                    </Row>
                    
                    <RefreshProjectModal
                        isDisplayed={this.state.isRefreshModalDisplayed}
                        projectId={this.state.refreshProjectId}
                        handleModalClose={this.handleRefreshModalClose} />
                </Fragment>
            }        
      </Fragment>
    )
  }
}


